var map = {
	"./Mitsubishi_Electric_logo.png": 821,
	"./arka.jpg": 31,
	"./ashok_dresses.png": 437,
	"./climaveneta.png": 4,
	"./getSponsorImages": 161,
	"./getSponsorImages.js": 161,
	"./inertia.png": 819,
	"./intervue.svg": 618,
	"./ovenly.jpeg": 548,
	"./siuk.png": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;